import { PERMISSIONS, type Permission } from '@repo/contracts';

/**
 * Who may open this app at all: the people who administer people or access.
 * A signed-in person holding neither has nothing to see here, however many
 * permissions they hold elsewhere. Phase 2 of docs/platform/access-model/plan.md adds
 * application owners to this list.
 */
export const APP_PERMISSIONS: readonly Permission[] = [
  PERMISSIONS.userManage,
  PERMISSIONS.roleManage,
];
